import { LocalizationModule } from "../../../Global/LocalizationModule";
import { PriceHelper } from "../../../../Lib/Helper/PriceHelper";
import { AxLoad } from "../../../../Lib/AxSystem/AxLoad";
import { RentalProdSelectionTimings } from "../../../../Models/Rental/Details/RentalProdSelectionTimings";

export abstract class RentDetailsProdSelectionAbstract {
    private locationId: number;
    private allProductsCount: number;

    private localizationModule: LocalizationModule;
    private priceHelper: PriceHelper;

    protected prodSelectionTimings: RentalProdSelectionTimings;

    abstract proceed();
    abstract getSelectionTotalPrice(): number;
    abstract getAllProductsCount(): number;
    protected abstract createPostData();

    constructor(bookingTimeParameterSelection: RentalProdSelectionTimings) {
        this.prodSelectionTimings = bookingTimeParameterSelection;
        this.allProductsCount = 0;

        this.localizationModule = AxLoad.GetModule<LocalizationModule>('LocalizationModule');
        this.priceHelper = new PriceHelper(this.localizationModule.getCultureInfo(), true);
    }

    getSelectedLocationId(): number {
        return this.locationId;
    };

    setLocationId(locationId: number) {
        this.locationId = locationId;
    }

    getPriceHelper(): PriceHelper {
        return this.priceHelper;
    }
}